import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import { useNavigate } from "react-router-dom";

const GRN = () => {
  const { data } = UseGetDashBoardData(`/dashboard/grn-approvals`);
  const navigate = useNavigate();

  const handleSliceClick = (status) => {
    const path = "/store/grn";
    navigate(path, { state: { status: status } });
  };

  return (
    <div className="bg-gray-50/60 p-3.5 rounded-xl border border-gray-100 flex flex-col justify-between">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-700">Goods Receipt Note</span>
        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200/50">
          {data?.total || 0} Total
        </span>
      </div>

      <div className="grid grid-cols-2 gap-2 mt-1">
        <button
          onClick={() => handleSliceClick("Pending")}
          className="flex flex-col p-1.5 rounded-lg bg-amber-50/60 hover:bg-amber-100/60 transition-colors text-left"
        >
          <span className="text-[10px] text-amber-700 font-medium">Pending</span>
          <span className="text-xs font-bold text-gray-800">{data?.pendding || "0"}</span>
        </button>

        <button
          onClick={() => handleSliceClick("Verified")}
          className="flex flex-col p-1.5 rounded-lg bg-purple-50/60 hover:bg-purple-100/60 transition-colors text-left"
        >
          <span className="text-[10px] text-purple-700 font-medium">Verified</span>
          <span className="text-xs font-bold text-gray-800">{data?.verified || "0"}</span>
        </button>
      </div>
    </div>
  );
};

export default GRN;
